import { UploadedFileCard } from "../File/UploadedFileCard";
import type { HumanHistoryMessage } from "../../types/HistoryMessage";

interface UserMessageProps {
  message: HumanHistoryMessage;
  index: number;
}

export function UserMessage({ message, index }: UserMessageProps) {
  return (
    <div key={`user-${index}`} className="flex flex-col items-end gap-2">
      {message.files && message.files.length > 0 && (
        <div className="flex flex-wrap gap-2 max-w-[700px] pl-4 sm:pl-12 justify-end">
          {message.files.map((fileWithUpload, fileIndex) => (
            <UploadedFileCard
              key={`${fileWithUpload.file.name}-${fileIndex}`}
              file={fileWithUpload.file}
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              onRemove={() => {}} // Files in messages are read-only
              disabled={true}
              isUploading={fileWithUpload.isUploading}
              uploadError={fileWithUpload.uploadError}
            />
          ))}
        </div>
      )}
      <div className="rounded-lg border border-base-300 bg-base-300 px-3 sm:px-4 py-2 text-sm max-w-[85%] sm:max-w-[80%]">
        {message.content}
      </div>
    </div>
  );
}
